import { FC, useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import { PageContainer } from 'src/features/Signup/components/organisms/PageContainer';
import { useDataIntegrationStepControls } from 'src/features/Signup/contexts/DataIntegrationStepControlsContext';

export const DataIntegrationFlow: FC = () => {
  const { controls } = useDataIntegrationStepControls();

  const onNext = useMemo(() => {
    if (!controls.onNext) return undefined;
    return () => {
      controls.onNext?.();
    };
  }, [controls]);

  const onBack = useMemo(() => {
    if (!controls.onBack) return undefined;
    return () => {
      controls.onBack?.();
    };
  }, [controls]);

  return (
    <PageContainer
      title={controls.title}
      subtitle={controls.subtitle}
      currentStep={controls.currentStep}
      onNext={onNext}
      onBack={onBack}
      isBackDisabled={controls.isBackDisabled}
      isNextDisabled={controls.isNextDisabled}
      isFormValid={controls.isFormValid}>
      <Outlet />
    </PageContainer>
  );
};
